import { render, staticRenderFns } from "./DiscountsDataTableRow.vue?vue&type=template&id=d67fe3a6&"
import script from "./DiscountsDataTableRow.vue?vue&type=script&lang=js&"
export * from "./DiscountsDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports